export default __webpack_public_path__ + "static/media/Scarlet Mark of Manipulation.33858d2c.jpg";